/**
 * 從 `File` 讀一段位元組。
 *
 * 只有這一支碰 `File`，其餘裁切模組都只拿 `Uint8Array`／`ArrayBuffer`：大檔
 * 裁切的整個重點就是**不要把整份讀進記憶體**，把讀取收在一個地方，才看得出
 * 每一條路徑到底讀了多少。
 */
export async function readSlice(file: Blob, start: number, end: number): Promise<ArrayBuffer> {
  const from = Math.max(0, Math.min(start, file.size))
  const to = Math.max(from, Math.min(end, file.size))
  return file.slice(from, to).arrayBuffer()
}

/** 同一段，但要的是位元組視圖。 */
export async function readSliceBytes(
  file: Blob,
  start: number,
  end: number
): Promise<Uint8Array> {
  return new Uint8Array(await readSlice(file, start, end))
}
